import styles from './PlanSelect.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button'
import { ArrowRight, Logout1, UserProfile1 } from 'blaze-ui/icons'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { PlanOptions } from './PlanOptions'
import { BillingFrequency } from 'stores/PaywallStore'
import { PaymentPlan, PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { WORKSPACE_SELECTION_PATH } from 'paths'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'
import { useCurrentPlan } from 'hooks/useCurrentPlan'

interface PlanSelectProps {
  onLogout: () => void
}

const PlanSelect = observer(({ onLogout }: PlanSelectProps) => {
  const { paywallStore, tierUsageStore } = useRootStore()
  const { data: currentPlan } = useCurrentPlan()

  const proPlan = tierUsageStore.paymentPlans.find((plan) => plan.key === PaymentPlanKey.BlazePro) as PaymentPlan

  const isInTrial = (currentPlan?.trial_days_left ?? -1) > 0

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <ResponsiveDesign.Mobile>
          <Button variant="ghost" color="var(--dark-80)" onPress={onLogout}>
            Logout
          </Button>
          <ButtonLink variant="ghost" color="var(--dark-80)" to={WORKSPACE_SELECTION_PATH}>
            Switch Account
          </ButtonLink>
        </ResponsiveDesign.Mobile>
        <ResponsiveDesign.Desktop>
          <div className={styles.buttonContainer}>
            <ButtonLink variant="ghost" color="var(--light-100)" frontIcon={UserProfile1} to={WORKSPACE_SELECTION_PATH}>
              Switch Account
            </ButtonLink>
            <Button variant="ghost" color="var(--light-100)" onPress={onLogout} frontIcon={Logout1}>
              Logout
            </Button>
          </div>
          <Heading level={1} color="var(--light-100)">
            Upgrade today to keep generating content that helps you grow in Blaze!
          </Heading>
        </ResponsiveDesign.Desktop>
      </div>
      <div className={styles.body}>
        <ResponsiveDesign.Mobile>
          <Heading level={2} color="var(--dark-80)">
            Upgrade today to keep generating content that helps you grow in Blaze!
          </Heading>
        </ResponsiveDesign.Mobile>
        <div className={styles.plansAndFooter}>
          <div className={styles.plans}>
            <PlanOptions
              plan={proPlan}
              isInTrial={isInTrial}
              defaultValue={paywallStore.selectedBillingFrequency}
              onChange={(frequency) => paywallStore.selectBillingFrequency(frequency as BillingFrequency)}
            />
          </div>
          <div className={styles.footer}>
            <Button variant="tertiary" size="lg" onPress={() => paywallStore.goToAllPlans()}>
              See All Plans
            </Button>
            <Button endIcon={ArrowRight} size="lg" onPress={() => paywallStore.goToCheckout()}>
              Grow 3x faster with Blaze
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
})

export default PlanSelect
